import { connect } from 'react-redux';
import { IState } from '../../store';

import { IModerationVerificationStoreProps, ModerationVerification } from './index';

export function mapStateToProps(state: IState): IModerationVerificationStoreProps {
  const { offerData } = state;
  const { moderationVerification } = offerData;

  return {
    moderationVerification,
    offerUserId: state.offerData.offer.userId,
    offerId: state.offerData.offer.id,
    publishedUserId: state.offerData.offer.publishedUserId,
    userId: state.offerData.user && state.offerData.user.realtyUserId,
  };
}

export const ModerationVerificationContainer = connect(mapStateToProps)(ModerationVerification);
